// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-field-with-spacing {
  margin-bottom: 1rem;
}

.small {
  font-size: 12px;
}

::ng-deep .ng-dropdown-panel {
  position: absolute !important;
  z-index: 1050;
  /* Ensure it is above other elements */
}

::ng-deep .ng-select {
  width: 100% !important;
}

::ng-deep .ng-select .ng-select-container {
  border-color: #DDE0E8 !important; /* Slightly darker than default #EBEDF2 */
}

::ng-deep .ng-select-container {
  overflow: visible !important;
}

::ng-deep .ng-dropdown-panel {
  max-height: 300px; /* Adjust based on your requirement */
  overflow-y: auto;
}

.select-wrapper {
  position: relative;
  width: 100%;
}

.select-input {
  min-width: 160px;
}

.is-invalid {
  border: 1px solid #D41D0D;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/select-input-row/select-input-row.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,6BAAA;EACA,aAAA;EACA,sCAAA;AACJ;;AAGA;EACI,sBAAA;AAAJ;;AAGA;EACI,gCAAA,EAAA,yCAAA;AAAJ;;AAGA;EACI,4BAAA;AAAJ;;AAGA;EACI,iBAAA,EAAA,qCAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,WAAA;AAAJ;;AAaA;EACI,gBAAA;AAVJ;;AAaA;EACE,yBAAA;EACA,kBAAA;AAVF","sourcesContent":[".form-field-with-spacing {\n  margin-bottom: 1rem;\n}\n\n.small {\n    font-size: 12px;\n}\n\n::ng-deep .ng-dropdown-panel {\n    position: absolute !important;\n    z-index: 1050; \n    /* Ensure it is above other elements */\n    // width: fit-content !important; /* Ensures dropdown width matches the container */\n}\n\n::ng-deep .ng-select {\n    width: 100% !important;\n}\n\n::ng-deep .ng-select .ng-select-container {\n    border-color: #DDE0E8 !important; /* Slightly darker than default #EBEDF2 */\n}\n\n::ng-deep .ng-select-container {\n    overflow: visible !important;\n}\n\n::ng-deep .ng-dropdown-panel {\n    max-height: 300px; /* Adjust based on your requirement */\n    overflow-y: auto;\n}\n\n.select-wrapper {\n    position: relative;\n    width: 100%;\n}\n\n// ::ng-deep .ng-select .ng-select-container {\n//     background-color: #FFFFFF;\n//     border: 1px solid #EBEDF2;\n//     font-size: 14px;\n//     font-weight: 300;\n//     padding-top: 5px;\n//     padding-bottom: 5px;\n//     border-radius: 8px;\n// }\n\n.select-input {\n    min-width: 160px;\n}\n\n.is-invalid {\n  border: 1px solid #D41D0D;\n  border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
